export default {"src":"/_next/static/media/logo.f67c24a7.svg","height":243,"width":1137,"blurWidth":0,"blurHeight":0};